import type { Session } from "@/features/coaching/models";
import { subscribedSessionSchema } from "@/features/coaching/models";

export const isSubscribedSession = (data: unknown): data is Session => {
  return subscribedSessionSchema.safeParse(data).success;
};
